import React from "react";
import { I18n } from "react-redux-i18n";
import { Modal, Button} from "semantic-ui-react";

import { Record } from "../../../../modules/bin/utility";

const PromoteToReceivedModal = (props) => {
  const {
    open,
    handleConfirm,
    translationKey,
    handleClose,
    record,
  } = props;

  const isLoading = Record.isRecordLoading(record);

  return (
    <Modal
      className="promote-to-received-modal"
      size="tiny"
      dimmer="inverted"
      open={open}
    >
      <Modal.Header>
        <label>{I18n.t(`${translationKey}.title`)}</label>
      </Modal.Header>
      <Modal.Content className="promote-to-received-modal-content">
        <span>{I18n.t(`${translationKey}.content`)}</span>
        <div className="promote-to-received-modal-buttons">
          <Button
            primary
            className="accept-button"
            onClick={handleConfirm}
            loading={isLoading}
          >
            {I18n.t(`${translationKey}.accept-button`)}
          </Button>
          <Button onClick={handleClose}>
            {I18n.t(`${translationKey}.decline-button`)}
          </Button>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default PromoteToReceivedModal;
